<agr-form-dialog
  [formGroup]="formGroup"
  [data]="data"
  (confirm)="confirm()"
  (cancel)="cancel()"
  class="flex--gutter-container"
>
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'ingredientName' | translate }}</mat-label>
      <input
        type="text"
        [placeholder]="'ingredientName' | translate"
        matInput
        formControlName="ingredientId"
        [matAutocomplete]="ingredientAutocomplete"
        data-test="edit-ingredientId"
      />
      <mat-autocomplete
        #ingredientAutocomplete="matAutocomplete"
        [displayWith]="displayIngredient()"
      >
        @for (option of filteredIngredients(); track option) {
          <mat-option [value]="option.id" data-test="edit-ingredients-option">
            {{ option.name }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto">
      <mat-select
        formControlName="calendarYear"
        [placeholder]="'year' | translate"
        data-test="edit-calendarYear"
      >
        @for (year of availableCropYears; track year) {
          <mat-option [value]="year" data-test="edit-calendarYear-options">
            {{ year }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'totalMalusPoints' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        placeholder="{{ 'totalMalusPoints' | translate }}"
        formControlName="malusPoints"
        data-test="edit-malusPoints"
      />
    </mat-form-field>
  </div>
  <div class="flex__child--auto">
    <div class="mat-slide-group">
      <mat-slide-toggle
        color="primary"
        formControlName="includeInSum"
        data-test="edit-includeInSum"
        >{{ 'includeInSum' | translate }}</mat-slide-toggle
      >
    </div>

    <div class="mat-slide-group">
      <mat-slide-toggle color="primary" formControlName="forbidden" data-test="edit-forbidden">{{
        'forbidden' | translate
      }}</mat-slide-toggle>
    </div>
  </div>
</agr-form-dialog>
